import { SET_SEARCH_RESULTS, SEARCH_FAILED, SEARCH_INITIATED, UPDATE_CURRENT_PAGE, SET_NEARBY_AGENTS } from './search.types';
export var setSearchResults = function setSearchResults(search) {
  return {
    type: SET_SEARCH_RESULTS,
    search: search
  };
};
export var searchFailed = function searchFailed(_searchFailed) {
  return {
    type: SEARCH_FAILED,
    searchFailed: _searchFailed
  };
};
export var searchInitiated = function searchInitiated() {
  return {
    type: SEARCH_INITIATED
  };
};
export var updateCurrentPage = function updateCurrentPage(search) {
  return {
    type: UPDATE_CURRENT_PAGE,
    search: search
  };
};
export var updateSortOrder = function updateSortOrder(search) {
  return {
    type: UPDATE_CURRENT_PAGE,
    search: search
  };
};
export var setNearbyAgents = function setNearbyAgents(search) {
  return {
    type: SET_NEARBY_AGENTS,
    search: search
  };
};